interface IOptionsMap {
  [key: string]: {
    uom: string
    currency: string
    timezone: string
    unitCost: number
  }
}

// export const UOM_OPTS = [
//   'Liters',
//   'Gallons(US)',
//   'Cubic Meters',
//   'Cubic Feet',
//   'Gallons(IMP)'
// ]

export const conversionFactors: { [key: string]: number } = {
  'Liters': 1,
  'Gallons(US)': 3.785411784,
  'Cubic Feet': 28.3168199078,
  'Cubic Meters': 1000,
  'Gallons(IMP)': 4.54609,
}

export const UOM_OPTS = Object.keys(conversionFactors)

export const OptionsMap: IOptionsMap = {
  'Belgium': { uom: 'Liters', currency: 'EUR', timezone: 'Europe/Brussels', unitCost: 4.40, },
  'Denmark': { uom: 'Liters', currency: 'EUR', timezone: 'Europe/Copenhagen', unitCost: 4.40, },
  'Germany': { uom: 'Liters', currency: 'EUR', timezone: 'Europe/Berlin', unitCost: 4.40, },
  'France': { uom: 'Liters', currency: 'EUR', timezone: 'Europe/Paris', unitCost: 4.40, },
  'Ireland': { uom: 'Liters', currency: 'EUR', timezone: 'Europe/Dublin', unitCost: 4.40, },
  'Netherlands': { uom: 'Liters', currency: 'EUR', timezone: 'Europe/Amsterdam', unitCost: 4.40, },
  'Northern Ireland': { uom: 'Liters', currency: 'GBP', timezone: 'Europe/Belfast', unitCost: 4.40, },
  'Sweden': { uom: 'Liters', currency: 'EUR', timezone: 'Europe/Helsinki', unitCost: 4.40, },
  'United Kingdom': { uom: 'Liters', currency: 'GBP', timezone: 'Europe/London', unitCost: 4.40, },
  'USA': { uom: 'Gallons(US)', currency: 'USD', timezone: 'America/Chicago', unitCost: 16.60, },
}

export const COUNTRY_OPTIONS: string[] = Object.keys(OptionsMap).filter(
  (value: string, index: number, self: string[]) => self.indexOf(value) === index,
)

export const PULSES_VALUES = [
  '0.01',
  '0.1',
  '0.2',
  '0.5',
  '1',
  '2',
  '10',
  '38',
  '60',
  '100',
  '119',
  '200',
  '210',
  '1000',
  '2000',
  '10000',
]

export const SECTOR_TYPES_OPTIONS: string[] = [
  'Bar',
  'Cinema',
  'Construction Site',
  'Gym',
  'Hospital',
  'Hotel',
  'Industrial',
  'Irrigation',
  'Manufacturing',
  'Nursing Home',
  'Office',
  'Pool',
  'Rain Water Harvester',
  'Real Estate',
  'Residential',
  'Restaurant',
  'School',
  'Service station',
  'Shop',
  'Shopping Center',
  'Stadium',
  'Student Accommodation'
]

export const FIRMWARE_OPTIONS: string[] = [
  'SM_V3_038.1.1.bin',
  'SM_V3_038.1.4.bin',
]

// export const CurrencyCountryMap: {[key: string]: string} =  {
// 	'Ireland': 'EUR',
//   'United Kingdom': 'GBP',
//   'Northern Ireland': 'GBP',
//   'USA': 'USD'
// }

// export const TimezoneCountryMap: {[key: string]: string} =  {
// 	'Ireland': 'Europe/Dublin',
//   'United Kingdom': 'Europe/London',
//   'Northern Ireland': 'Europe/Belfast',
//   'USA': 'America/Chicago'
// }

// type CountryKeys = keyof typeof CurrencyCountryMap;
// type CurrencyValue = typeof CurrencyCountryMap[CountryKeys];

// export const COUNTRY_OPTIONS: string[] = Object.keys(CurrencyCountryMap).filter((value: string, index: number, self:string[]) => self.indexOf(value) === index)
// export const CURRENCY_OPTIONS: string[] = Object.values(CurrencyCountryMap).filter((value: string, index: number, self:string[]) => self.indexOf(value) === index)

// export const UOMCountryMap: {[key: string]: string} =  {
// 	'Ireland': 'Liters',
//   'United Kingdom': 'Liters',
//   'Northern Ireland': 'Liters',
//   'USA': 'Gallons(US)'
// }

export const UOM_OPTIONS: string[] = Object.values(OptionsMap)
  .map((value) => value.uom)
  .filter((uom: string, index: number, self: string[]) => self.indexOf(uom) === index)

export const CURRENCY_OPTIONS: string[] = Object.values(OptionsMap)
  .map((value) => value.currency)
  .filter((currency: string, index: number, self: string[]) => self.indexOf(currency) === index)

export const UPLOAD_FREQ_MINS: number[] = [60, 120, 180, 240, 360, 720, 1080, 1440]
